/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createAccount} from '../api'

export const useMutationCreateAccount = createReactQueryMutationHook('createAccount', createAccount)
